import React from "react";
import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { Lines, FadeUp } from "../components/Reveal";
import ProductCard from "../components/ProductCard";
import { useSiteContent } from "../lib/siteContent";

export default function LatestDrop() {
    const { products, loading } = useStore();
    const { latestDrop } = useSiteContent();
    const drop = latestDrop.length
        ? latestDrop.map((h) => products.find((p) => p.id === h)).filter(Boolean).slice(0, 4)
        : products.slice(0, 4);

    return (
        <section data-testid="latest-drop" className="mx-auto max-w-[1600px] px-5 py-24 sm:px-8 lg:px-16 lg:py-36">
            <div className="mb-14 flex items-end justify-between">
                <div>
                    <p className="mb-3 text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">Drop 001</p>
                    <Lines
                        lines={["Latest Drop"]}
                        className="font-display text-3xl font-extrabold uppercase tracking-tight text-[#0A0A0A] sm:text-5xl"
                    />
                </div>
                <Link
                    data-testid="latest-drop-view-all"
                    to="/shop"
                    className="link-underline hidden font-display text-[10px] font-bold uppercase tracking-[0.3em] text-[#8E8D8A] transition-colors hover:text-[#0A0A0A] sm:block"
                >
                    View All
                </Link>
            </div>
            <div className="grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4 lg:gap-8">
                {loading
                    ? [...Array(4)].map((_, i) => (
                          <div key={i} className="aspect-[4/5] animate-pulse rounded-2xl bg-[#ECEAE4] md:rounded-none" />
                      ))
                    : drop.map((p, i) => (
                          <FadeUp key={p.id} delay={i * 0.1}>
                              <ProductCard product={p} priority={i < 2} />
                          </FadeUp>
                      ))}
            </div>
        </section>
    );
}
